import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import {
  useGetSearchByEmailQuery,
  useGetLookupByEmailQuery,
  useThreadsMutation,
  useGetTemplateQuery,
  useReplyQuery,
} from "../../../Services/email/EmailTemplate";
import EmailTemplateModal from "../EmailTemplateModal";
import { toast } from "react-toastify";
import TicketsDetailsModal from "../inboxEmailModal/TicketsDetailsModal";
import { Box, IconButton, Tooltip, Divider } from "@mui/material";
import AddNewTicketContactModal from "../../ticket/AddNewTicketContactModal";
import DispositionModal from "../../../components/ticket/DispositionModal";
import {
  useReplyMailMutation,
  useUpdateDispositionMutation,
} from "../../../Services/email/EmailInbox";
import LoadingSpinner from "../../LoadingSpinner";
import { Loader } from "react-bootstrap-typeahead";
import DispositionTicketModal from "../../ticket/DispositionTicketModal";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CancelIcon from "@mui/icons-material/Cancel";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import EmailIcon from "@mui/icons-material/Email";
import SendIcon from "@mui/icons-material/Send";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DownloadIcon from "@mui/icons-material/Download";
import ReplyIcon from "@mui/icons-material/Reply";
import ReplyAllIcon from "@mui/icons-material/ReplyAll";

interface IProps {
  otherMailDetails: any;
  mailDetails: any;
  replyText: any;
  uuid: any;
  refetchSpecificThreads: any;
  setShowReplyCard: any;
  storedMailHistory: any;
  storedTicketId: any;
  setReplyText: any;
  signatureData: any;
}

const ReplyCard: React.FC<IProps> = ({
  otherMailDetails,
  mailDetails,
  replyText,
  uuid,
  refetchSpecificThreads,
  setShowReplyCard,
  storedMailHistory,
  storedTicketId,
  setReplyText,
  signatureData,
}) => {
  const [showCCField, setShowCCField] = useState<any>(replyText === "replyAll");
  const [showBccField, setShowBccField] = useState<any>(
    replyText === "replyAll"
  );
  const [emails, setEmails] = useState<any>([]);
  const [cc, setCc] = useState<any>([]);
  const [bcc, setBcc] = useState<any>([]);
  const [subject, setSubject] = useState<any>("");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const [selectedTemplateDescription, setSelectedTemplateDescription] =
    useState<any>("");
  const [storeTemplateData, setStoreTemplateData] = useState<any>([]);
  const [editorHtml, setEditorHtml] = useState<any>("");
  const [inputValue, setInputValue] = useState("");
  const [ccInputValue, setCcInputValue] = useState("");
  const [bccInputValue, setBccInputValue] = useState("");
  const [queryParam, setQueryParam] = useState();
  const [emailOptions, setEmailOptions] = useState<any[]>([]);
  const [lookupEmail, setLookupEmail] = useState("");
  const [dispositionModal, setDispositionModal] = useState<boolean>(false);
  const [ticketDetailsModal, setTicketDetailsModal] = useState<boolean>(false);
  const [lastSelectedDisposition, setLastSelectedDisposition] =
    useState<any>("");
  const [emailNotPresent, setEmailNotPresent] = useState<any>("");
  const [files, setFiles] = useState([]);
  const [templateAttachment, setTemplateAttachment] = useState<any>();
  const [isAddNewContactModalOpen, setAddNewContactModalOpen] = useState(false);
  const [selectedContact, setSelectedContact] = useState<any>();
  const [storeNewEmailId, setStoreNewEmailId] = useState("");
  const [liftingReplyLoader, setLiftingReplyLoader] = useState(false);
  const [checkingForReplyApi, setCheckingForReplyApi] = useState(false);
  const [openNonValueDispositionModal, setOpenNonValueDispositionModal] =
    useState(false);
  const [signature, setSignature] = useState<any>({});

  const [trigger, { isLoading: loading }] = useUpdateDispositionMutation();
  const [replyMail, { status: replyStatus }] = useReplyMailMutation();

  const { data } = useGetSearchByEmailQuery(queryParam, {
    skip: !queryParam,
  });
  const { data: lookupEmailData } = useGetLookupByEmailQuery(lookupEmail, {
    skip: !lookupEmail,
  });
  const { data: getTemplate } = useGetTemplateQuery({
    team_id: localStorage.getItem("teamId"),
  });

  const { data: getReplyMail } = useReplyQuery({
    replyText,
    uuid,
    mailDetails,
  });
  const [thredsEmail] = useThreadsMutation();

  const signatureArray = Array.isArray(signatureData)
    ? signatureData
    : signatureData
    ? [signatureData]
    : [];

  const nonDefaultSignatures = signatureArray.filter(
    (sig) => sig.is_default === false
  );

  const extractEmailOptions = (data) => {
    if (!data) return [];
    return data.map((item) => ({ label: item.email }));
  };

  useEffect(() => {
    if (data) {
      setEmailOptions(extractEmailOptions(data));
    }
  }, [data]);

  useEffect(() => {
    if (getTemplate) {
      setStoreTemplateData(getTemplate);
    }
  }, [getTemplate]);

  useEffect(() => {
    if (nonDefaultSignatures.length > 0) {
      setSignature(nonDefaultSignatures);
      if (!editorHtml && !selectedTemplateDescription) {
        setEditorHtml(nonDefaultSignatures[0].signature_html);
      }
    } else {
      setSignature([]);
    }
  }, [signatureData]);

  useEffect(() => {
    if (signatureData) {
      const signatures = Array.isArray(signatureData)
        ? signatureData
        : [signatureData];
      setSignature(signatures);

      if (signatures.length > 0 && signatures[0].signature_html) {
        setEditorHtml(signatures[0].signature_html);
      }
    }
  }, [signatureData]);

  useEffect(() => {
    if (selectedTemplateDescription && selectedTemplateDescription.content) {
      setSubject(selectedTemplateDescription.subject || "");

      const signatureHtml =
        signature && signature.length > 0 ? signature[0].signature_html : "";

      const newContent = signatureHtml
        ? `${selectedTemplateDescription.content}<br/><br/>${signatureHtml}`
        : selectedTemplateDescription.content;

      setEditorHtml(newContent);
    }
  }, [selectedTemplateDescription, signature]);

  useEffect(() => {
    if (getReplyMail) {
      if (replyText === "reply") {
        const toEmails = Array.from(new Set(getReplyMail.to));
        setEmails(toEmails);
        setCc([]);
        setBcc([]);
      } else if (replyText === "replyAll") {
        const toEmails = Array.from(new Set(getReplyMail.to));
        const ccEmails = Array.from(new Set(getReplyMail.cc || []));
        setEmails(toEmails);
        setCc(ccEmails);
      }
 
      if (!selectedTemplateDescription) {
        const signatureHtml =
          signature && signature.length > 0 ? signature[0].signature_html : "";
 
        if (signatureHtml) {
          setEditorHtml(`<br/><br/>${signatureHtml}`);
        }
      }
    }
  }, [replyText, getReplyMail, signature]);

  const handleInputChange = (event, newInputValue, setInputValue) => {
    if (event?.type === "click" || event?.type === "keydown") {
      setInputValue("");
      const emailOptionExists = emailOptions.some(
        (option) => option.label === newInputValue
      );

      if (!emailOptionExists) {
        setEmailNotPresent(false);
        openContactModal();
        setStoreNewEmailId(event.target.value);
      }
    }
    if (event?.type === "change") {
      const queryParams: any = {
        email: newInputValue,
      };

      setInputValue(newInputValue);
      setQueryParam(queryParams);
    }
  };

  const handleAddEmail = (email, setEmails, emails) => {
    if (email && isValidEmail(email)) {
      if (!emails.includes(email.trim())) {
        setEmails([...emails, email.trim()]);
        setInputValue("");
      }
    }
  };

  const handleDeleteEmail = (emailToDelete, setEmails, emails) => {
    setEmails(emails.filter((email) => email !== emailToDelete));
  };

  const isValidEmail = (email) => {
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  };

  const handleCopyEmail = (e: React.MouseEvent, email: string) => {
    e.stopPropagation();
    e.preventDefault();
    navigator.clipboard.writeText(email).then(
      () => toast.success("Email copied to clipboard"),
      () => toast.error("Failed to copy")
    );
  };

  const handleFileChange = async (event) => {
    const newFiles = Array.from(event.target.files);
    const filePromises = newFiles.map((file: any) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const fileData = {
            file_name: file.name,
            file: e.target.result.split(",")[1],
          };
          resolve(fileData);
        };
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    });

    try {
      const fileDataArray = await Promise.all(filePromises);
      setFiles((prevFiles) => [...prevFiles, ...fileDataArray]);
    } catch (error) {
      console.error("Error reading files:", error);
      toast.error("An error occurred while uploading files. Please try again.");
    }
  };

  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "700px",
      height: "600px",
    },
  };

  const customModalStyles2 = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "500px",
      maxHeight: "500px",
    },
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const afterOpenModal = () => {};

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const closeNonDispositionValueModal = () => {
    setOpenNonValueDispositionModal(false);
  };

  const handleEditorChange = (content) => {
    setEditorHtml(content);
  };

  const openDispositionModal = () => {
    setDispositionModal(true);
  };

  const afterOpenDispositionModal = () => {};

  const closeDispositionModal = () => {
    setDispositionModal(false);
  };

  const openContactModal = () => {
    setAddNewContactModalOpen(true);
  };

  const closeContactModal = () => {
    setAddNewContactModalOpen(false);
  };

  const toggleCCField = () => {
    setShowCCField(!showCCField);
  };

  const toggleBccField = () => {
    setShowBccField(!showBccField);
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
    "align",
    "script",
    "background",
    "blockquote",
    "code-block",
    "header",
    "indent",
    "list",
    "script",
  ];

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }, { font: [] }],
      ["bold", "italic", "underline", "strike"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "blockquote", "code-block"],
      [{ color: [] }, { background: [] }, { align: [] }],
      ["clean"],
    ],
  };

  const handleSubmit = async () => {
    const showAssignError = otherMailDetails?.action?.assignee;

    if (editorHtml === undefined) {
      return toast.error("Text field may not be blank");
    }
    if (!showAssignError) {
      return toast.error("Please assign this email");
    }

    const allEmails = [...emails, ...cc, ...bcc].filter(
      (v, i, arr) => arr.indexOf(v) === i
    );
    const apiPort = process.env.REACT_APP_API_PROTOCOL;
    const fetchingTenant = window.location.hostname.split(".")[0];

    for (const email of allEmails) {
      try {
        const res = await axios.get(
          `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/customers/contacts/search-by-email/`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("auth-token")}`,
            },
            params: { email },
          }
        );
        if (!res.data || res.data.length === 0) {
          setEmailNotPresent(email);
          setStoreNewEmailId(email);
          setAddNewContactModalOpen(true);
          return;
        }
      } catch (error) {
        toast.error("Failed to fetch customer email suggestions.");
        return;
      }
    }

    if (!!showAssignError) {
      openDispositionModal();
    }

    if (
      otherMailDetails?.action?.ticket === null &&
      otherMailDetails?.action?.disposition
    ) {
      const selectedEmailId = otherMailDetails?.id;
      let queryParam = {
        to: emails,
        html_content: editorHtml,
        bcc: bcc,
        cc: cc,
        attachments: files,
        reply_and_close: true,
        template_attachments: Array.isArray(templateAttachment)
          ? templateAttachment.map((attachment) => attachment.id)
          : [],
        is_replied: true,
      };

      const replyResponse = await replyMail({
        body: queryParam,
        selectedEmailId,
      });

      if (replyResponse && replyResponse.data) {
        toast.success("Email sent successfully");
        setCheckingForReplyApi(true);
        refetchSpecificThreads();
        setBcc([]);
        setEmails([]);
        setCc([]);
        setEditorHtml("");
        setSubject("");
        setTemplateAttachment([]);
        setShowReplyCard(false);
        setReplyText("");
        setShowReplyCard(false);
        closeModal();
      } else if ("data" in replyResponse?.error) {
        const errorData = replyResponse.error?.data as {
          detail?: string[];
        };
        const errorMessage = errorData?.detail?.[0];

        toast.error(errorMessage);
      }
    } else if (
      otherMailDetails?.action?.ticket === null &&
      !otherMailDetails?.action?.disposition
    ) {
      setOpenNonValueDispositionModal(true);
    }
  };

  const apiPort = process.env.REACT_APP_API_PROTOCOL;
  const fetchingTenant = window.location.hostname.split(".")[0];

  const handleDeleteFile = (fileToDelete) => () => {
    setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToDelete));
  };

  const handleDownloadFile = (fileId) => {
    window.open(`${fileId}`, "_blank");
  };

  const handleDeleteAttachmentFile = (fileToDeleteId) => async () => {
    setTemplateAttachment((prev) => {
      const updatedAttachments = prev.filter(
        (file) => String(file.id) !== String(fileToDeleteId)
      );

      return updatedAttachments;
    });
  };

  useEffect(() => {
    setCcInputValue("");
    setInputValue("");
    setBccInputValue("");
    setEditorHtml("");
  }, [checkingForReplyApi]);

  const value = "nonDispositionValue";

  const renderEmailField = (
    label: string,
    emails: string[],
    setEmails: any,
    inputValue: string,
    setInputValue: any,
    placeholder: string = "Add recipients"
  ) => (
    <Box sx={{ mb: 0 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 3,
          py: 2,
          borderBottom: "1px solid #e8e8e8",
        }}
      >
        <Box
          sx={{
            minWidth: "60px",
            fontWeight: 600,
            fontSize: "14px",
            color: "#2c3e50",
          }}
        >
          {label}
        </Box>
        <Box sx={{ flex: 1, ml: 2 }}>
          <Autocomplete
            freeSolo
            multiple={false}
            options={emailOptions}
            getOptionLabel={(option: any) => option.label}
            onChange={(event, value) => {
              if (value && isValidEmail(value.label)) {
                handleAddEmail(value.label, setEmails, emails);
                setInputValue("");
              }
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) =>
              handleInputChange(event, newInputValue, setInputValue)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={emails.length === 0 ? placeholder : ""}
                size="small"
                variant="standard"
                sx={{
                  "& .MuiInput-underline:before": {
                    borderBottom: "none",
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottom: "none",
                  },
                  "& .MuiInput-underline:after": {
                    borderBottom: "none",
                  },
                }}
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleAddEmail(inputValue, setEmails, emails);
                    setInputValue("");
                    e.preventDefault();
                  }
                }}
                onBlur={async () => {
                  if (inputValue && isValidEmail(inputValue)) {
                    try {
                      const res = await axios.get(
                        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/customers/contacts/search-by-email/`,
                        {
                          headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                              "auth-token"
                            )}`,
                          },
                          params: { email: inputValue.trim() },
                        }
                      );
                      if (!res.data || res.data.length === 0) {
                        setEmailNotPresent(inputValue.trim());
                        setStoreNewEmailId(inputValue.trim());
                        setAddNewContactModalOpen(true);

                        handleAddEmail(inputValue, setEmails, emails);
                        setInputValue("");
                        return;
                      } else {
                        handleAddEmail(inputValue, setEmails, emails);
                        setInputValue("");
                      }
                    } catch (error) {
                      toast.error(
                        "Failed to fetch customer email suggestions."
                      );
                    }
                  }
                }}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <Stack
                      direction="row"
                      spacing={0.5}
                      alignItems="center"
                      flexWrap="wrap"
                      sx={{ gap: 0.5 }}
                    >
                      {emails?.map((email, index) => (
                        <Chip
                          key={index}
                          label={email}
                          onDelete={() =>
                            handleDeleteEmail(email, setEmails, emails)
                          }
                          size="small"
                          deleteIcon={
                            <span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                              <span className="chip-delete-x-only" style={{ display: "inline-flex", cursor: "pointer" }}>
                                <CancelIcon sx={{ fontSize: 16 }} />
                              </span>
                              <IconButton
                                size="small"
                                sx={{ p: 0.2 }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCopyEmail(e, email);
                                }}
                                title="Copy email"
                              >
                                <ContentCopyIcon sx={{ fontSize: 14 }} />
                              </IconButton>
                            </span>
                          }
                          sx={{
                            backgroundColor: "#f0f4f8",
                            color: "#2c3e50",
                            fontWeight: 500,
                            fontSize: "13px",
                            minHeight: 34,
                            px: 1.25,
                            "& .MuiChip-deleteIcon": {
                              color: "inherit",
                              fontSize: "18px",
                            },
                            "& .MuiChip-deleteIcon .chip-delete-x-only": {
                              color: "#64748b",
                            },
                            "& .MuiChip-deleteIcon .chip-delete-x-only:hover": {
                              color: "#ef4444",
                            },
                          }}
                        />
                      ))}
                    </Stack>
                  ),
                }}
              />
            )}
          />
        </Box>
        {label === "To:" && (
          <Box sx={{ display: "flex", gap: 1.5, ml: 2 }}>
            <Box
              component="span"
              onClick={toggleCCField}
              sx={{
                fontSize: "13px",
                fontWeight: 500,
                color: showCCField ? "#6366f1" : "#64748b",
                cursor: "pointer",
                "&:hover": {
                  color: "#4f46e5",
                },
              }}
            >
              Cc
            </Box>
            <Box
              component="span"
              onClick={toggleBccField}
              sx={{
                fontSize: "13px",
                fontWeight: 500,
                color: showBccField ? "#6366f1" : "#64748b",
                cursor: "pointer",
                "&:hover": {
                  color: "#4f46e5",
                },
              }}
            >
              Bcc
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );

  return (
    <>
      {liftingReplyLoader ? (
        <LoadingSpinner />
      ) : (
        <Box
          sx={{
            mt: 3,
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
            backgroundColor: "#ffffff",
            border: "1px solid #e8e8e8",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 3,
              py: 2.5,
              backgroundColor: "#f8fafc",
              borderBottom: "1px solid #e8e8e8",
            }}
          >
               <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: "8px",
                  backgroundColor: "#f0f4ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {replyText === "replyAll" ? (
                  <ReplyAllIcon sx={{ fontSize: 18, color: "#5b7cfa" }} />
                ) : (
                  <ReplyIcon sx={{ fontSize: 18, color: "#5b7cfa" }} />
                )}
              </Box>
              <Box
                component="h3"
                sx={{
                  m: 0,
                  fontSize: "15px",
                  fontWeight: 600,
                  color: "#1a1a1a",
                }}
              >
                {replyText === "replyAll" ? "Reply All" : "Reply"}
              </Box>
            </Box>
            <Tooltip title="Close">
              <IconButton
                onClick={() => setShowReplyCard(false)}
                sx={{
                  color: "#64748b",
                  "&:hover": {
                    backgroundColor: "#f1f5f9",
                    color: "#1e293b",
                  },
                }}
                size="small"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>

          {/* Email Fields */}
          <Box>
            {renderEmailField("To:", emails, setEmails, inputValue, setInputValue)}
            {showCCField &&
              renderEmailField("Cc:", cc, setCc, ccInputValue, setCcInputValue)}
            {showBccField &&
              renderEmailField("Bcc:", bcc, setBcc, bccInputValue, setBccInputValue)}
          </Box>

          {/* Editor */}
          <Box sx={{ p: 3 ,mb:5 }}>
            <ReactQuill
              theme="snow"
              value={editorHtml}
              onChange={handleEditorChange}
              modules={modules}
              formats={formats}
              style={{
                height: "250px",
                borderRadius: "8px",
              }}
            />
          </Box>

          {/* Attachments */}
          {(files.length > 0 || templateAttachment?.length > 0) && (
            <Box sx={{ px: 3, pb: 2, mt: 8 }}>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {files.map((file, index) => (
                  <Chip
                    key={index}
                    label={file.file_name}
                    onDelete={handleDeleteFile(file)}
                    deleteIcon={<DeleteOutlineIcon />}
                    sx={{
                      backgroundColor: "#f0f4f8",
                      color: "#2c3e50",
                      fontWeight: 500,
                      fontSize: "13px",
                      height: "32px",
                      "& .MuiChip-deleteIcon": {
                        color: "#64748b",
                        "&:hover": {
                          color: "#ef4444",
                        },
                      },
                    }}
                  />
                ))}
                {templateAttachment?.map((file, index) => (
                  <Chip
                    key={index}
                    label={file.file_name}
                    onClick={() => handleDownloadFile(file.file)}
                    onDelete={handleDeleteAttachmentFile(file.id)}
                    deleteIcon={<DeleteOutlineIcon />}
                    icon={<DownloadIcon sx={{ fontSize: 16 }} />}
                    sx={{
                      backgroundColor: "#eef2ff",
                      color: "#6366f1",
                      fontWeight: 500,
                      fontSize: "13px",
                      height: "32px",
                      cursor: "pointer",
                      "& .MuiChip-deleteIcon": {
                        color: "#64748b",
                        "&:hover": {
                          color: "#ef4444",
                        },
                      },
                      "&:hover": {
                        backgroundColor: "#e0e7ff",
                      },
                    }}
                  />
                ))}
              </Box>
            </Box>
          )}

          {/* Footer */}
          <Divider />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 3,
              py: 2.5,
              backgroundColor: "#f8fafc",
            }}
          >
            <Box sx={{ display: "flex", gap: 1 }}>
              <Tooltip title="Attach file">
                <label htmlFor="attachFileInput">
                  <IconButton
                    component="span"
                    sx={{
                      color: "#64748b",
                      "&:hover": {
                        backgroundColor: "#f1f5f9",
                        color: "#4f46e5",
                      },
                    }}
                  >
                    <AttachFileIcon fontSize="medium" />
                  </IconButton>
                  <input
                    type="file"
                    id="attachFileInput"
                    className="d-none"
                    multiple
                    onChange={handleFileChange}
                  />
                </label>
              </Tooltip>
              <Tooltip title="Email template">
                <IconButton
                  onClick={openModal}
                  sx={{
                    color: "#64748b",
                    "&:hover": {
                      backgroundColor: "#f1f5f9",
                      color: "#4f46e5",
                    },
                  }}
                >
                  <EmailIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
            </Box>
            <Box
              component="button"
              onClick={handleSubmit}
              disabled={replyStatus === "pending"}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 3,
                py: 1.25,
                backgroundColor: "#6366f1",
                color: "#ffffff",
                border: "none",
                borderRadius: "8px",
                fontWeight: 600,
                fontSize: "14px",
                cursor: "pointer",
                transition: "all 0.2s",
                "&:hover": {
                  backgroundColor: "#4f46e5",
                  transform: "translateY(-1px)",
                  boxShadow: "0 4px 6px -1px rgba(37, 99, 235, 0.3)",
                },
                "&:active": {
                  transform: "translateY(0)",
                },
                "&:disabled": {
                  backgroundColor: "#94a3b8",
                  cursor: "not-allowed",
                  transform: "none",
                },
              }}
            >
              {replyStatus === "pending" ? (
                <>
                  Sending... <Loader />
                </>
              ) : (
                <>
                  Send
                  <SendIcon fontSize="small" />
                </>
              )}
            </Box>
          </Box>
        </Box>
      )}

      <ReactModal
        isOpen={isAddNewContactModalOpen}
        onRequestClose={() => setAddNewContactModalOpen(false)}
        style={customModalStyles}
        contentLabel="New Contact"
        shouldCloseOnOverlayClick={false}
      >
        <AddNewTicketContactModal
          closeModal={() => setAddNewContactModalOpen(false)}
          emailNotPresent={emailNotPresent}
          setSelectedContact={setSelectedContact}
          storeNewEmailId={storeNewEmailId}
          setEmailNotPresent={setEmailNotPresent}
        />
      </ReactModal>

      {ticketDetailsModal && (
        <TicketsDetailsModal
          closeModal={() => setTicketDetailsModal(false)}
          lastSelectedDisposition={lastSelectedDisposition}
          isOpen={ticketDetailsModal}
          emails={emails}
          cc={cc}
          bcc={bcc}
          editorHtml={editorHtml}
          otherMailDetails={otherMailDetails}
          refetchSpecificThreads={refetchSpecificThreads}
          setShowReplyCard={setShowReplyCard}
          files={files}
          templateAttachment={templateAttachment}
        />
      )}

      <ReactModal
        isOpen={openNonValueDispositionModal}
        onRequestClose={closeNonDispositionValueModal}
        style={customModalStyles}
        contentLabel="New Disposition"
        shouldCloseOnOverlayClick={false}
      >
        <DispositionTicketModal
          isLoading={loading}
          trigger={trigger}
          closeModal={closeNonDispositionValueModal}
          storedDisposition={storedMailHistory}
          refetch={refetchSpecificThreads}
          ticketId={storedTicketId}
          value={value}
        />
      </ReactModal>

      {otherMailDetails?.action?.ticket === null ? (
        <></>
      ) : (
        <ReactModal
          isOpen={dispositionModal}
          onAfterOpen={afterOpenDispositionModal}
          onRequestClose={closeDispositionModal}
          style={customModalStyles2}
          contentLabel="Disposition"
          shouldCloseOnOverlayClick={false}
        >
          <DispositionModal
            isLoading={loading}
            trigger={trigger}
            closeModal={closeDispositionModal}
            storedDisposition={storedMailHistory}
            refetch={refetchSpecificThreads}
            ticketId={storedTicketId || uuid}
            otherMailDetails={otherMailDetails}
            emails={emails}
            editorHtml={editorHtml}
            cc={cc}
            bcc={bcc}
            templateAttachment={templateAttachment}
            files={files}
            setCheckingForReplyApi={setCheckingForReplyApi}
            setLiftingReplyLoader={setLiftingReplyLoader}
            setShowReplyCard={setShowReplyCard}
          />
        </ReactModal>
      )}

      <ReactModal
        isOpen={isModalOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="Email templates"
        shouldCloseOnOverlayClick={false}
      >
        <EmailTemplateModal
          closeModal={closeModal}
          setSelectedTemplateDescription={setSelectedTemplateDescription}
          storeTemplateData={storeTemplateData}
          setTemplateAttachment={setTemplateAttachment}
        />
      </ReactModal>
    </>
  );
};

export default ReplyCard;